import React from 'react';
import { Route } from 'react-router-dom';

import Docs from 'features/docs/pages/Docs';
import SetConsultants from 'features/docs/pages/SetConsultants';
import ViewDoc from 'features/docs/pages/ViewDoc';

export const docsRoutes = (
  <Route path='docs'>
    <Route index element={<Docs />} />
    <Route path='set-consultants' element={<SetConsultants />} />
    <Route path=':id' element={<ViewDoc />} />
  </Route>
);

export const docsTitles = [
  { path: '/docs/set-consultants', title: 'Назначить консультантов' },
  { match: /^\/docs\/[^/]+$/, title: 'Просмотр документа' },
  { path: '/docs', title: 'Документы' },
];
